import React from 'react';
import { CTASection } from '../../components/CTASection';
import { Palette, CheckCircle, DollarSign, Sparkles, Shield, Zap, Package } from 'lucide-react';
export function DirectToGarment() {
  const benefits = [{
    icon: <Package className="w-6 h-6" data-id="element-1329" />,
    title: 'No Minimums Required',
    description: 'Order as few or as many as you need—perfect for any project size'
  }, {
    icon: <Zap className="w-6 h-6" data-id="element-1330" />,
    title: 'Free Shipping',
    description: 'Every order ships free—no hidden fees, no surprises'
  }, {
    icon: <DollarSign className="w-6 h-6" data-id="element-1331" />,
    title: 'Lowest Prices Guaranteed',
    description: '30-50% below competitors through innovative efficiency'
  }, {
    icon: '<Shield className="w-6 h-6"/>',
    title: 'Quality Guarantee',
    description: "Free replacement if you're not 100% satisfied."
  }];
  const features = ['Full-color, photo-quality prints', 'Soft, breathable feel (no thick plastisol)', 'Perfect for complex designs and gradients', 'Fast turnaround times', 'Eco-friendly water-based inks', 'Ideal for small batches and one-offs'];
  return <div className="flex flex-col w-full" data-id="element-1332">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-wh-teal to-teal-600 py-20" data-id="element-1333">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1334">
          <div className="flex justify-center mb-6" data-id="element-1335">
            <Palette className="w-16 h-16 text-white" data-id="element-1336" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-1337">
            Direct-to-Garment Printing
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto" data-id="element-1338">
            Unleash your creativity with vibrant, full-color custom prints. No
            minimums, free shipping, and unbeatable prices—perfect for any
            budget.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white" data-id="element-1339">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1340">
          <div className="max-w-4xl mx-auto mb-16" data-id="element-1341">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-1342">
              Custom Printed Shirts & Group Gear Made Easy
            </h2>
            <div className="prose prose-lg max-w-none text-gray-700 space-y-4" data-id="element-1343">
              <p data-id="element-1344">
                Get ready to turn heads with custom group gear for everything
                from spirited t-shirts for your social club to stylish apparel
                for your entire team. Direct-to-Garment (DTG) printing delivers
                stunning, full-color designs with photo-quality detail—perfect
                for complex artwork, gradients, and vibrant graphics.
              </p>
              <p data-id="element-1345">
                At Wear Haus Designs, we believe everyone deserves fabulous gear
                without breaking the bank. That'That\'s why we offer no minimum
                orders, free shipping, and transparent pricing—making us the
                best deal for custom printed t-shirts around. Whether you need
                just a few shirts or a whole fleet of fashionable fit-outs,
                we've got the expertise to make it happen!
              </p>
            </div>
          </div>

          {/* Benefits Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-1346">
            {benefits.map((benefit, index) => <div key={index} className="bg-gray-50 rounded-xl p-8 border border-gray-100" data-id="element-1347">
                <div className="flex items-start gap-4" data-id="element-1348">
                  <div className="flex-shrink-0 w-12 h-12 bg-wh-pink rounded-lg flex items-center justify-center text-white" data-id="element-1349">
                    {benefit.icon}
                  </div>
                  <div data-id="element-1350">
                    <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1351">
                      {benefit.title}
                    </h3>
                    <p className="text-gray-600" data-id="element-1352">{benefit.description}</p>
                  </div>
                </div>
              </div>)}
          </div>

          {/* Why Choose DTG */}
          <div className="bg-gradient-to-br from-wh-teal to-teal-600 rounded-2xl p-12 text-white mb-16" data-id="element-1353">
            <h2 className="text-3xl font-bold mb-8 text-center" data-id="element-1354">
              Why Choose Direct-to-Garment?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-1355">
              {features.map((feature, index) => <div key={index} className="flex items-center gap-3" data-id="element-1356">
                  <CheckCircle className="w-6 h-6 text-wh-yellow flex-shrink-0" data-id="element-1357" />
                  <span className="text-lg" data-id="element-1358">{feature}</span>
                </div>)}
            </div>
          </div>

          {/* Three Pillars */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-1359">
            <div className="bg-white rounded-xl p-8 border-2 border-wh-pink" data-id="element-1360">
              <div className="w-12 h-12 bg-wh-pink rounded-lg flex items-center justify-center text-white mb-4" data-id="element-1361">
                <DollarSign className="w-6 h-6" data-id="element-1362" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1363">
                Lowest Prices Guaranteed
              </h3>
              <p className="text-gray-700" data-id="element-1364">
                Printing companies charge high rates due to industry
                inefficiencies. Through innovative technology, we've created a
                more efficient and affordable option with prices{' '}
                <span className="font-bold text-wh-pink" data-id="element-1365">
                  30-50% below all competitors
                </span>
                .
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 border-2 border-wh-teal" data-id="element-1366">
              <div className="w-12 h-12 bg-wh-teal rounded-lg flex items-center justify-center text-white mb-4" data-id="element-1367">
                <Sparkles className="w-6 h-6" data-id="element-1368" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1369">
                Impeccable Print Quality
              </h3>
              <p className="text-gray-700" data-id="element-1370">
                We deliver high-quality results because of our deep
                understanding of screen printing and DTG processes. We guarantee
                our products will be{' '}
                <span className="font-bold text-wh-teal" data-id="element-1371">
                  free of material defects
                </span>
                —or we'll replace it for free.
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 border-2 border-wh-yellow" data-id="element-1372">
              <div className="w-12 h-12 bg-wh-yellow rounded-lg flex items-center justify-center text-gray-900 mb-4" data-id="element-1373">
                <Shield className="w-6 h-6" data-id="element-1374" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1375">
                Transparent Pricing
              </h3>
              <p className="text-gray-700" data-id="element-1376">
                With Wear Haus, the price you see is the price you'll pay—
                <span className="font-bold text-wh-yellow" data-id="element-1377">no hidden fees</span>
                . Use our Quote Generator to estimate your order cost
                immediately. And remember, we offer free shipping on all orders!
              </p>
            </div>
          </div>

          {/* CTA Box */}
          <div className="bg-gradient-to-br from-wh-pink to-pink-600 rounded-2xl p-12 text-center text-white" data-id="element-1378">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1379">
              We're Your T-Shirt Printing Experts for Any Budget
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto" data-id="element-1380">
              Big or small, we do it all! Ready to bring your vision to life
              with stunning DTG prints?
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1381">
              <a href="/contact" className="inline-flex items-center justify-center px-8 py-4 bg-white text-wh-pink font-bold rounded-lg hover:bg-gray-100 transition-colors" data-id="element-1382">
                Get a Quote
              </a>
              <a href="tel:260-463-7373" className="inline-flex items-center justify-center px-8 py-4 bg-wh-yellow text-gray-900 font-bold rounded-lg hover:bg-yellow-400 transition-colors" data-id="element-1383">
                Call 260-463-7373
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <CTASection data-id="element-1384" />
    </div>;
}